module.exports = __webpack_public_path__ + "img/salesforce.77003633.svg";